// extracted by mini-css-extract-plugin
module.exports = {"calculator-await__content":"CalculatorAwait_calculator-await__content__2ULty"};